export default __webpack_public_path__ + "static/media/link-external.f301c456.svg";